import { isArray, isArrayEmpty } from '../../../utility/helpers';
import { formatDate } from '../../../utility/dateUtils';
import { primaryPalette } from '../../../styles/theme';
import { ReactComponent as EditIcon } from '../../../assets/icons/edit-dark.svg';
import { ReactComponent as ManageJobsIcon } from '../../../assets/icons/call_to_action_dark.svg';
import { FIELD_TYPES } from '../../../constants/fieldTypes';

export const DATE_FORMAT = 'MMM d, yyyy';

export const FILTER_MAP = {
  DEPARTMENT: 'department',
  JOB: 'job',
  STAGE: 'stage',
  TAG: 'tag',
};

export const getTableHeaders = labels => [
  {
    id: 1,
    title: labels.name,
    rowKey: 'name',
    minWidth: 140,
    maxWidth: '1.5fr',
  },
  {
    id: 2,
    title: labels.job,
    rowKey: 'job',
    maxWidth: '1fr',
  },
  {
    id: 3,
    title: labels.stage,
    rowKey: 'stage',
    maxWidth: '1fr',
  },
  {
    id: 4,
    title: labels.createdAt,
    rowKey: 'createdAt',
    maxWidth: '1fr',
  },
  {
    id: 5,
    title: labels.modifiedOn,
    rowKey: 'modifiedOn',
    maxWidth: '1fr',
  },
];

export const getHeaderActions = labels => [
  {
    id: 'actions-column',
    title: labels.actions,
    rowKey: 'actions',
    rowCellClass: 'actions-cell',
    isHeaderAction: true,
    minWidth: 55,
    maxWidth: 55,
  },
];

const getCandidateJobInformations = steps => {
  if (isArrayEmpty(steps)) {
    return { jobs: [], stages: [] };
  }
  const info = steps.reduce(
    (acc, curr) => {
      return {
        jobs: [
          ...acc.jobs,
          {
            name: curr.job,
            color: primaryPalette.bluish8,
            step_id: curr.id,
            job_id: curr.job_id,
          },
        ],
        stages: [
          ...acc.stages,
          {
            name: curr.title,
            color: primaryPalette.bluish8,
            step_id: curr.id,
            job_id: curr.job_id,
          },
        ],
      };
    },
    { jobs: [], stages: [] }
  );

  return { jobs: info.jobs, stages: info.stages };
};

export const prepareTableData = (
  users,
  renderUser,
  renderActions,
  renderList
) => {
  return users.map(user => {
    const { jobs, stages } = getCandidateJobInformations(user.steps);

    return {
      id: user.id,
      name: renderUser(user),
      job: renderList(jobs),
      stage: renderList(stages),
      createdAt: formatDate(user.created_at, DATE_FORMAT) || '-',
      modifiedOn: formatDate(user.updated_at, DATE_FORMAT) || '-',
      actions: renderActions(user),
    };
  });
};

export const getMenuItems = (
  translations,
  user,
  handleEditCandidate,
  handleManageJobs
) => {
  return [
    {
      type: 'edit',
      label: translations.menuItemLabels.edit,
      action: () => handleEditCandidate(user),
      shouldItemRender: () => true,
      icon: EditIcon,
    },
    {
      type: 'manageJobs',
      label: translations.menuItemLabels.manageJobs,
      action: () => handleManageJobs(user),
      shouldItemRender: () => true,
      icon: ManageJobsIcon,
    },
  ];
};

export const getFilterOptions = (
  filterOptions,
  translations,
  hasAll = false
) => {
  const options = filterOptions.map(filterOption => {
    return {
      id: filterOption.id,
      name: filterOption.name ? filterOption.name : filterOption.title,
    };
  });

  if (hasAll) {
    return [{ id: 0, name: translations.all }, ...options];
  }

  return options;
};

export const filterTagsFromCategories = categories => {
  return categories?.reduce((acc, curr) => {
    return [...acc, ...curr.tags];
  }, []);
};

export const getStagesForFilter = jobs => {
  return jobs.reduce((acc, curr) => {
    return [
      ...acc,
      ...curr.steps.filter(
        step => !acc.map(item => item.title).includes(step.title)
      ),
    ];
  }, []);
};

export const getJobsForSelectList = jobs =>
  jobs.reduce((acc, curr) => {
    return curr.steps.length
      ? [
          ...acc,
          {
            id: curr.id,
            title: curr.title,
          },
        ]
      : acc;
  }, []);

export const getMapedStages = jobs => {
  const mappedStepIds = {};
  const mappedStepNames = jobs.reduce((acc, curr) => {
    curr.steps.forEach(step => {
      const value = acc[step.title];
      mappedStepIds[step.id] = step.title;
      if (!value) {
        acc[step.title] = step.id;
      } else {
        acc[step.title] = isArray(value)
          ? [...value, step.id]
          : [value, step.id];
      }
    });

    return acc;
  }, {});

  return { mappedStepNames, mappedStepIds };
};

export const prepareJobsInitialData = jobsForCandidate => ({
  jobs: jobsForCandidate,
});

export const MANAGE_JOBS_FIELDS = [
  {
    name: 'subtitle',
    type: FIELD_TYPES.SUBTITLE,
  },
  {
    name: 'jobs',
    type: FIELD_TYPES.SELECT,
    translationKey: 'jobs',
    optionsKey: 'allJobs',
    isMulti: true,
    shouldReturnOption: true,
    parser: {
      value: 'id',
      label: 'title',
    },
  },
];
